import DaySummaryCell from "./DaySummaryCell";

export default DaySummaryCell;
